<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fill="currentColor"
      d="M12.667 1.333H4.18a2 2 0 0 0-1.967 1.64L1.367 7.64A2 2 0 0 0 3.333 10h3.04L6 10.953a2.753 2.753 0 0 0 2.593 3.714.668.668 0 0 0 .607-.394L11.1 10h1.567a2 2 0 0 0 2-2V3.333a2 2 0 0 0-2-2ZM10 9.193l-1.813 4.08a1.419 1.419 0 0 1-.92-1.853l.353-.953a1.334 1.334 0 0 0-1.247-1.8h-3.04a.667.667 0 0 1-.513-.24.667.667 0 0 1-.153-.547l.846-4.667a.667.667 0 0 1 .667-.546H10v6.526ZM13.333 8a.667.667 0 0 1-.666.667h-1.334v-6h1.334a.667.667 0 0 1 .666.666V8Z"
    />
  </svg>
</template>
